<template>
    <div class="container">
        <div class="row gx-4">
            <div :class="`col-12 col-md-${parseInt(12 / plans.length)}`" v-for="plan in plans">
                <div class="card shadow-lg mb-6 mb-md-0 h-100">
                    <div class="card-body px-4 h-100 d-flex flex-column justify-content-between">
                        <div class="info">
                            <div class="text-center mb-3">
                                <span class="badge rounded-pill bg-primary-soft">
                                    <span class="h6 text-uppercase">{{ plan.name }}</span>
                                </span>
                            </div>
                            <div class="d-flex justify-content-center">
                                <span class="h4 mb-0 mt-2">{{ plan.currency__symbol }}</span>
                                <span class="price display-4 mb-0" data-monthly="plan.price">{{ plan.price }}</span>
                            </div>
                            <p class="text-center text-muted mb-1 text-wrap">per Cache API request</p>
                            <p v-if="rubRate" class="text-center text-muted mb-1 small">~{{ toRub(plan.price) }} ₽ за запрос</p>
                            <p v-if="plan.mcp_price" class="text-center text-muted mb-3 small">
                                MCP: <strong>{{ plan.currency__symbol }}{{ plan.mcp_price }}</strong>/req
                                <span v-if="rubRate"> (~{{ toRub(plan.mcp_price) }} ₽)</span>
                            </p>
                            <p class="text-center text-muted mb-3 small">
                                Min balance: <strong>{{ plan.currency__symbol }}{{ plan.min_amount }}</strong>
                                <span v-if="rubRate"> (~{{ toRub(plan.min_amount) }} ₽)</span>
                            </p>
                            <p class="text-center text-muted mb-5 text-wrap preserve-linebreaks">{{ plan.description }}</p>
                            <!--div class="d-flex" v-for="spec in plan.specifications">
                                <div class="badge badge-rounded-circle bg-success-soft mt-1 me-2"><i class="fe fe-check"></i></div>
                                <p v-html="spec"></p>
                            </div-->
                        </div>
                        <router-link :to="{path: `/plan/choose/${plan.id}`}"
                                     class="btn w-100 btn-primary" role="button" :aria-disabled="true"
                                     :class="{'btn-primary-soft': !plan.is_popular}"
				     v-if="!isCurrentPlan(plan.id)">
                            {{ button }}
                        </router-link>
                        <span class="btn w-100 btn-success disabled" v-else>Current</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        button: {
            type: String,
            default: 'Buy'
        },
        currentPlanId: {
            type: Number
        },
    },
    data() {
        return {
            plans: []
        }
    },
    computed: {
        rubRate() {
            return this.$state.rubRate
        }
    },
    created() {
        this.get()
    },
    methods: {
        get() {
            this.$services.Plan().get().then(resp => {
                this.plans = resp.body
            })
        },
        isCurrentPlan(id) {
            return id == this.currentPlanId
        },
        toRub(usd) {
            if (!this.rubRate) return ''
            const rub = usd * this.rubRate
            if (rub < 0.01) return rub.toFixed(4)
            if (rub < 1) return rub.toFixed(2)
            if (rub >= 100) return Math.ceil(rub / 100) * 100
            return Math.round(rub)
        },
    }
}
</script>
<style scoped>
.preserve-linebreaks {
  white-space: pre-line !important;
}
</style>
